import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetClubNameFilter, resetDepartmentsFilter, setClubNameFilter, setDepartmentsFilter } from '../../../redux/reducers/common';
import AutoComplete from '../../AutoComplete';
import { Box } from '@mui/material';
import { getClubDepartments } from '../../../api/club';
import { setDepartmentList } from '../../../redux/reducers/evaluation';
import { useTranslation } from 'react-i18next';
import { resetActionsArchivedFilter, resetActionsLinkedToFilter, resetProjectsArchivedFilter, setActionsArchivedFilter, setActionsLinkedToFilter, setProjectsArchivedFilter } from '../../../redux/reducers/actionPlan';
import { getClubOptions, getClubValue, getFinanceReponse, getLeagueOptions, getLeagueValue, getRatingOptions, getRatingValue, getYearOptions, getYearValue } from '../../../pages/licenseAnalytics/licenseAnalyticsSupport/getLicenseAnalyticsActions';
import { SingleOption } from '../../../pages/licenseAnalytics/licenseAnalyticsSupport/typeInterfaces';
import { setClubValue, setLeagueValue, setRatingValue, setYearOptions, setYearValue } from '../../../redux/reducers/licenceAnalytics';

const styles: any = {
  root: {
    display: 'flex',
    gap: '10px',
    marginLeft: '5px',
    justifyContent: 'space-between',
    paddingTop: '5px',
    marginRight: '25px',
  },
};

const getYearList = (response: { year: string | number }[]): SingleOption[] => {
  const resultArr: SingleOption[] | any = [];
  // Extracting unique years without using Set/spread to avoid downlevel-iteration issues
  const yearValues: (string | number)[] = response.map((item) => item.year);
  const uniqueYears: (string | number)[] = yearValues.filter((year, index, arr) => arr.indexOf(year) === index);
  // Converting to the desired format
  uniqueYears.forEach((year) => resultArr.push({ id: year.toString(), name: year.toString() }));
  return resultArr.reverse();
};

const FiltersWrapper: React.FC = () => {
  const [t] = useTranslation();
  const leaguesList: SingleOption[] = useSelector(getLeagueOptions);
  const selectedLeagues: SingleOption | SingleOption[] | undefined = useSelector(getLeagueValue);
  const ratingsList: SingleOption[] = useSelector(getRatingOptions);
  const selectedRatings: SingleOption | SingleOption[] | undefined = useSelector(getRatingValue);
  const yearList: SingleOption[] = useSelector(getYearOptions);
  const selectedYear: SingleOption | undefined = useSelector(getYearValue);
  const clubList:any = useSelector(getClubOptions);
  const selectedClub:any = useSelector(getClubValue);
  const isAdmin = useSelector((state:any) => state.common.isAdmin);
  const clubDetails = useSelector((state:any) => { return state.clubDetails });
  const financeResponse: any = useSelector(getFinanceReponse);
  const [isConstructOptions, setConstructOptions] = useState(true);

  const dispatch = useDispatch();
  
  const manageLeagueSelect = (option:any) => {
    const index = selectedLeagues?.findIndex((obj:any) => obj.id == option.id);
    let tempArr:any = selectedLeagues && selectedLeagues?.length > 0 ? [...selectedLeagues] : [];
      if (index !== -1 && index !== undefined) {
        tempArr.splice(index, 1);
    } else {
      tempArr.push(option);
    }
    dispatch(setLeagueValue({newValue: tempArr}));
  }

  const manageRatingsSelect = (newRating:any) => {
    const index = selectedRatings?.findIndex((obj:any) => obj.id == newRating.id);
    let tempArr:any = selectedRatings && selectedRatings?.length > 0 ? [...selectedRatings] : [];
      if (index !== -1 && index !== undefined) {
        tempArr.splice(index, 1);
    } else {
      tempArr.push(newRating);
    }
    dispatch(setRatingValue({newValue: tempArr}));
  }
  
  const manageYearSelect = (newValue:any) => {
    dispatch(setYearValue({ newValue }));
  }
  
  const manageClubSelect = (newValue:any) => {
    dispatch(setClubValue({ newValue }));
  }

  useEffect(() => {
    if (isConstructOptions && financeResponse?.length > 0) {
      const options = getYearList(financeResponse);
      dispatch(setYearOptions({ options }));
      setConstructOptions(false);
    }
  }, [financeResponse]);
  
  useEffect(() => {
    if (!isAdmin) {
      const club = clubList.filter((option:any) => option.id === clubDetails?.id)?.[0];
      dispatch(setClubValue({ newValue: club }));
    } 
  }, [clubList, clubDetails, isAdmin, dispatch]);

  return (
    <div className="filtersWrapperRoot" style={styles.root}>
      {/* League filter */}
      <Box sx={{ width: '200px' }}>
        <AutoComplete 
        options={leaguesList}
        selectedValues={selectedLeagues}
        handleMenuClick={(d:any) => {manageLeagueSelect(d)}} 
        label={t('LEAGUE')}
        clickReset={() => {}}
        isMultiple={true}
        />
      </Box>
      {/* Ratings filter */}
      <Box sx={{ width: '200px' }}>
        <AutoComplete 
        options={ratingsList}
        selectedValues={selectedRatings}
        handleMenuClick={(d:any) => {manageRatingsSelect(d)}} 
        label={t("RATING")}
        clickReset={() => {}}
        isMultiple={true}
        />
      </Box>
      {/* Year filter */}
      <Box sx={{ width: '200px' }}>
        <AutoComplete 
        options={yearList}
        selectedValues={selectedYear}
        handleMenuClick={(d:any) => {manageYearSelect(d)}} 
        label={t('YEAR')}
        clickReset={() => {}}
        isMultiple={false}
        />
      </Box>
      {/* Club filter */}
      <Box sx={{ width: '200px' }}>
        <AutoComplete 
        options={isAdmin ? clubList : clubList.filter((option:any) => option.id == clubDetails?.id)}
        selectedValues={selectedClub || { id: undefined, name: 'NONE' }}
        // options={isAdmin ? [{ id: undefined, name: t('NONE') }, ...clubList] : clubList.filter((option:any) => option.id == clubDetails?.id)}
        // selectedValues={selectedClub || { id: undefined, name: t('NONE') }}
        handleMenuClick={(d:any) => {manageClubSelect(d)}} 
        label={t('DC_5_CLUB')}
        clickReset={() => {}}
        isMultiple={false}
        addnone={true}
        />
      </Box>
    </div>
  );
};

export default FiltersWrapper;
